import { Fragment } from 'react';
import { getRandomUid } from 'utilities/uuid.service';
import Select from 'react-select';

function SelectBox({
  children,
  labelProps = {},
  selectProps = {},
  fieldErrors = {},
  options = [],
  defaultLook = true,
  onChangeEvent = () => {},
}) {
  const { label = 'Select label', ...rest } = labelProps;
  const { id, className = '', ...props } = selectProps;

  const selectBoxID = id ?? getRandomUid();

  let selectBoxClasses = '__pinkColor';
  const { errorMessage = '' } = fieldErrors;

  if (errorMessage) {
    selectBoxClasses = `${className} border border-danger`;
  }

  return (
    <Fragment>
      <label htmlFor={selectBoxID} {...rest}>
        {label}
      </label>
      {defaultLook ? (
        <select id={selectBoxID} {...props} className={selectBoxClasses}>
          {children}
        </select>
      ) : (
        <Select
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              borderColor: '#e9baf0',
              'box-shadow': '0 0.8rem 1.2rem rgba(20, 102, 204, 0.14)',
            }),
          }}
          value={options?.find(({ value }) => value === selectProps.value) ?? null}
          options={options}
          className={selectBoxClasses}
          onChange={onChangeEvent}
          classNamePrefix="__pinkColor"
        />
      )}
    </Fragment>
  );
}

export default SelectBox;
